var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_9359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75468 5.10164C9.76365 5.10761 9.77264 5.11361 9.78167 5.11963L17.6932 10.394C17.9221 10.5466 18.1344 10.6881 18.2974 10.8195C18.4675 10.9567 18.6681 11.147 18.7835 11.4253C18.9361 11.7932 18.9361 12.2066 18.7835 12.5745C18.6681 12.8528 18.4675 13.0431 18.2974 13.1803C18.1344 13.3118 17.9221 13.4532 17.6932 13.6058L9.75472 18.8982C9.4749 19.0847 9.22329 19.2525 9.00979 19.3682C8.79614 19.484 8.50288 19.6163 8.1606 19.5959C7.72279 19.5697 7.31834 19.3533 7.05374 19.0035C6.84687 18.73 6.79429 18.4126 6.77211 18.1706C6.74996 17.9288 6.74998 17.6264 6.75 17.2901L6.75 6.74213C6.75 6.73128 6.75 6.72047 6.75 6.70969C6.74998 6.3734 6.74996 6.071 6.77211 5.82918C6.79429 5.58719 6.84687 5.26979 7.05374 4.99633C7.31834 4.64655 7.72279 4.4301 8.1606 4.40396C8.50288 4.38352 8.79614 4.51583 9.00979 4.63162C9.22328 4.74732 9.47488 4.91507 9.75468 5.10164ZM8.26884 5.9365C8.26783 5.94559 8.26683 5.95542 8.26586 5.96605C8.25076 6.13085 8.25 6.36304 8.25 6.74213V17.2577C8.25 17.6368 8.25076 17.869 8.26586 18.0338C8.26683 18.0444 8.26783 18.0542 8.26884 18.0633C8.27696 18.0591 8.28571 18.0545 8.29509 18.0494C8.44059 17.9706 8.6342 17.8424 8.94962 17.6321L16.8363 12.3743C17.0987 12.1994 17.2525 12.096 17.3558 12.0127C17.3614 12.0082 17.3665 12.0039 17.3714 11.9999C17.3665 11.9959 17.3614 11.9916 17.3558 11.9871C17.2525 11.9038 17.0987 11.8004 16.8363 11.6255L8.94962 6.3677C8.6342 6.15742 8.44059 6.02926 8.29508 5.9504C8.28571 5.94532 8.27697 5.9407 8.26884 5.9365Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_9359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.f91cb2ce.svg";
export { ForwardRef as ReactComponent };